import { AppState } from '../root.reducer';

export const getClaimStripePaymentsStateByClaimId = (state: AppState, claimId: string) => {
  return state.claimStripePayments.byClaimId[claimId];
};
